import React from 'react';
import { Button, Card, Result } from 'antd'
import { useNavigate } from 'react-router-dom'
import { errorMessages } from '../constants/ErrorMessages'

export const ErrorResult = ({ error }: { error: any }) => {
  const navigate = useNavigate()

  const navigateToHome = () => {
    navigate('/mdm')
  }

  const getStatusIcon = (status: number) => {
    switch (status) {
      case 403:
        return '403'
      case 500:
        return '500'
      case 404:
        return '404'
      default:
        return 'error'
    }
  }

  return (
    <Card>
      <Result
        status={getStatusIcon(error.status)}
        title={errorMessages[error.status] ?? 'Something went wrong...'}
        subTitle={error.status}
        extra={
          <Button onClick={navigateToHome} type='primary'>
            Home
          </Button>
        }
      />
    </Card>
  )
}
